import useSWR from 'swr'
import useMe from '@/hooks/useMe'
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function useNavigationViews() {
    const { id, role } = useMe()
    const { requestGet } = useAxiosApi()
    return useSWR(id && role ? ['table-view-navigation', id, role] : null,
        async () => (await requestGet('/table-views/navigation')).data, { refreshInterval: 60000 })
}
